@if ((to.label && field.parent?.parent?.type !== "multischema") || key) {
  <div class="object-wrapper">
    <app-panel-expandable
      [text]="key && field.parent?.type !== 'array' ? to.label || key : ''"
      [body]="formlyObjectField"
      [fixed]="field.parent?.type === 'array'"
      [expanded]="isOneOfTheChildrenRequired(field)"
      [required]="to.required && field.parent?.type !== 'array'"
      [tooltip]="key + ''"
      [enabled]="!field.props.disabled"
      [overlayTooltip]="field.props['overlayTooltip'] || ''"
      [description]="
        field.parent?.type !== 'array' && to.description
          ? formlyFieldInfo
          : undefined
      "
    >
    </app-panel-expandable>
    <ng-template #formlyFieldInfo>
      <!--ignore description for array items - key in this case is the index of the item in the array-->
      {{ to.description }}
    </ng-template>
    <ng-template #formlyObjectField>
      <div>
        @for (f of field.fieldGroup; track f) {
          <formly-field [field]="f"></formly-field>
        }
      </div>
    </ng-template>
  </div>
}

<!-- for object with no label and no key don't add panel -->
@if (
  (!to.label && !key) || (!key && field.parent?.parent?.type === "multischema")
) {
  <div>
    <div>
      @for (f of field.fieldGroup; track f) {
        <formly-field [field]="f"></formly-field>
      }
    </div>
  </div>
}
